// extracted by mini-css-extract-plugin
export var layoutContainer = "_8r-0";
export var layoutContainerNoRounding = "_8r-6";
export var layoutContainerOpen = "_8r-5";
export var layoutContainerResizing = "_8r-1";
export var mainContent = "_8r-2";
export var resizeDivider = "_8r-3";
export var slidePanel = "_8r-4";